import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/*
https://medium.com/thecodecampus-knowledge/the-easiest-way-to-unsubscribe-from-observables-in-angular-5abde80a5ae3
https://github.com/w11k/ngx-componentdestroyed/blob/master/src/index.ts
*/
@Injectable()
export abstract class BaseObserver implements OnDestroy {
  protected destroy$ = new Subject<void>();

  constructor() {
    const originalOnDestroy = this.ngOnDestroy;
    this.ngOnDestroy = () => {
      if (originalOnDestroy) {
        originalOnDestroy.apply(this);
      }
      this.destroy$.next();
      this.destroy$.complete();
    };
  }

  ngOnDestroy() {
    // no-op, but here to implement interface
  }
}
